// extracted by mini-css-extract-plugin
export default {"address-list":"AddressList_address-list__d6VDc"};